import { Add, ArticleOutlined, DataSaverOff, Search, Settings } from '@mui/icons-material'
import Close from '@mui/icons-material/Close'
import { useMediaQuery } from '@mui/material'
import { useEffect, useState } from 'react'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import {
  LoadingContext,
  M_Button,
  M_CheckBox,
  M_ElementDrawer,
  M_Fieldset,
  M_FormFavorites,
  M_SimpleTable,
} from 'src/M_Components'
import { QuoteChargesSettings } from './QuoteChargesSettings'
import { QuoteFormField } from './QuoteFormField'

export const QuoteCharges = ({
  dataState,
  setDataState,
  passedRowState,
  setPassedRowState,
  triggerAddNewCharge,
  setTriggerAddNewCharge
}) => {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()

  const [openSettingsPopup, setOpenSettingsPopup] = useState(false)
  const [isMultiEditable, setIsMultiEditable] = useState(!dataState.isMultiEdit)
  const [isQuantityRequired, setIsQuantityRequired] = useState(false)

  const matches10 = useMediaQuery('(min-width:1150px)')
  const matches15 = useMediaQuery('(min-width:615px)')

  const multipleOptions = [
    { label: t('Equipment'), value: 'E' },
    { label: t('Document'), value: 'D' },
    { label: t('Process'), value: 'P' },
    { label: t('Weight'), value: 'W' },
    { label: t('Measures'), value: 'M' },
    { label: t('Percentage'), value: 'C' },
    { label: t('Other'), value: 'O' },
    { label: t('TEU'), value: 'T' },
    { label: t('Quantity'), value: 'Q' },
    { label: t('KG 6 DM3'), value: 'G' },
    { label: t('K6'), value: 'K' },
  ]

  const goalOptions = [
    { label: t('Line'), value: 'L' },
    { label: t('Agent Only'), value: 'A' },
    { label: t('Commission'), value: 'O' },
  ]

  const formFields = [
    {
      size: 180,
      display: t('ServiceCode'),
      required: true,
      code: 'serviceCode',
      type: 'foreignKey',
      entity: 'ServiceType',
      tableLabel: t('ServiceType'),
      filterField: 'code',
      labelFields: ['ServiceCode'],
      fields: [
        { key: 'ServiceCode', value: 'serviceCode' },
        { key: 'ServiceName', value: 'serviceName' },
        { key: 'Id', value: 'serviceId' },
        { key: 'SalesValue', value: 'salesValue' },
        { key: 'PayableHow', value: 'payableHow' },
        { key: 'PayableHowValue', value: 'payableHowValue' },
        { key: 'PayingCompany', value: 'payingCompany' },
        { key: 'PayingCompanyValue', value: 'payingCompanyValue' },
        { key: 'SalesMultiple', value: 'multiple' },
        { key: 'SalesMultipleValue', value: 'multipleValue' },
      ],
      favoritesFieldName: t('ServiceCode'),
      favoritesGroupName: 'Charges',
      favoritesVarKey: 'serviceCode',
      favoritesIdKey: 'serviceId',
    },
    {
      size: 170,
      display: t('ServiceName'),
      code: 'serviceName',
      type: 'disabled',
    },
    {
      size: 240,
      display: t('Supplier'),
      required: false,
      code: 'supplierCode',
      type: 'foreignKey',
      entity: 'Account',
      filterField: 'AccountCode',
      labelFields: ['AccountCode'],
      fields: [
        { key: 'AccountCode', value: 'supplierCode' },
        { key: 'Id', value: 'supplierId' },
      ],
      favoritesFieldName: t('Supplier'),
      favoritesGroupName: 'Charges',
      favoritesVarKey: 'supplierCode',
      favoritesIdKey: 'supplierId',
    },
    {
      size: 80,
      display: t('CostValue'),
      required: false,
      code: 'costValue',
      type: 'number',
    },
    {
      size: 145,
      display: t('CostCurrency'),
      required: false,
      code: 'costCurrencyCode',
      type: 'foreignKey',
      entity: 'Currency',
      filterField: 'code',
      labelFields: ['Code'],
      fields: [
        { key: 'Code', value: 'costCurrencyCode' },
        { key: 'Id', value: 'costCurrencyId' },
      ],
    },
    {
      size: 145,
      display: t('Currency'),
      required: true,
      code: 'currencyCode',
      type: 'foreignKey',
      entity: 'Currency',
      filterField: 'code',
      labelFields: ['Code'],
      fields: [
        { key: 'Code', value: 'currencyCode' },
        { key: 'Id', value: 'currencyId' },
      ],
    },
    {
      size: 80,
      display: t('SalesValue'),
      required: true,
      code: 'salesValue',
      type: 'number',
    },
    {
      size: 80,
      display: t('Quantity'),
      required: true,
      code: 'quantity',
      type: 'number',
    },
    {
      size: 170,
      display: t('Multiple'),
      required: true,
      code: 'multiple',
      type: 'select',
      options: multipleOptions,
      extraField: 'multipleValue',
    },
    {
      size: 140,
      display: t('Goal'),
      required: true,
      code: 'goal',
      type: 'select',
      options: goalOptions,
      extraField: 'goalValue',
    },
  ]

  const newCharge = (isFirst) => {
    let newObj = {}
    let newArray = (isFirst && []) || dataState['charges']

    let counter = dataState['counterCharges'] + 1
    changes('counterCharges', counter, setDataState)

    formFields.forEach((obj) => {
      newObj[obj?.code] = ''
      if (obj?.labelFields) {
        obj?.fields.forEach((extra) => {
          newObj[extra?.value] = ''
        })
      }
      if (obj?.extraField) {
        newObj[obj?.extraField] = ''
      }
    })

    newObj['id'] = counter
    newArray?.push(newObj)
    changes('charges', newArray, setDataState)
  }

  const chargesElements = (row, field, index) => {
    if (ctx.isLoad) return <></>

    return (
      <div>
        <QuoteFormField
          fields={field}
          index={index}
          data={row}
          setData={setDataState}
          hideLabels={true}
          returnFunc={saveChargesValues}
          size={field?.size}
          options={field?.options}
        />
      </div>
    )
  }

  const saveChargesValues = (row, fields, obj) => {
    let oldArray = dataState['charges']

    if(!oldArray) return;

    setIsQuantityRequired(fields.code === 'multiple' && obj.value === 'Q')

    let newArray = oldArray.map((old) => {
      if (old.id === row.id) {
        let newObj = { ...old }
        if (fields.type === 'foreignKey') {
          fields.fields.forEach((field) => {
            if (obj) {
              newObj[field.value] = obj[field.key]
            } else {
              newObj[field.value] = ''
            }
          })
        } else if (fields.type === 'select') {
          if (obj) {
            newObj[fields.code] = obj.label
            newObj[fields.extraField] = obj.value
          } else {
            newObj[fields.code] = ''
            newObj[fields.extraField] = ''
          }
        } else {
          newObj[fields.code] = obj
        }
        return newObj
      }
      return old
    })

    changes('charges', newArray, setDataState)
  }

  const openSettings = (row) => {
    setPassedRowState(row)
    setOpenSettingsPopup(true)
  }

  const closeSettings = () => {
    setPassedRowState({})
    setOpenSettingsPopup(false)
  }

  const deleteCharges = (row) => {
    const newCharges = dataState?.charges.filter(
      (charge) => charge.id !== row.id,
    )
    changes('charges', newCharges, setDataState)
  }

  const calculateTotalProfit = (dta, eventData) => {
    let totalCost = 0
    let totalSales = 0

    eventData?.props?.value
      .filter((obj) => obj.lumpSumCode === dta.lumpSumCode)
      .forEach((obj) => {
        const quantity = obj.multipleValue === 'Q' ? Number(obj['quantity']) || 1 : 1
        totalCost = totalCost + Number(obj['costValue'])
        totalSales = totalSales + Number(obj['salesValue']) * quantity
      })

    const total = (totalSales - totalCost).toFixed(2)

    return (total > 0 && `+${total}`) || total
  }

  const calculateTotalSum = (dta, eventData, type) => {
    let total = 0

    eventData?.props?.value
      .filter((obj) => obj.lumpSumCode === dta.lumpSumCode)
      .forEach((obj) => {
        const quantity = (type === 'salesValue' && obj.multipleValue === 'Q') ? Number(obj['quantity']) || 1 : 1
        total = total + Number(obj[type]) * quantity
      })

    return total
  }

  return (
    <M_FormFavorites
      entityName="Quotes"
      pageUrl="QuoteCharges"
      varNameDict={new Map()}
      setVarNameDict={() => {}}
      onAfterApply={() => {}}
    >
      <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '25px',
              marginLeft: '10px',
            }}
          >
            <ArticleOutlined style={{ marginRight: '10px', scale: '1.3' }} />{' '}
            {t('Charges')}
            {dataState.isMultiEdit && <M_CheckBox checked={isMultiEditable} onChange={(e) => {setIsMultiEditable(e.target.checked)}} />}
          </div>
        }
        headerElement={
          matches15 && (
            <div style={{ margin: '20px', display: 'flex' }}>
              {/* <M_Button
                bold
                normal
                hoverEffect
                label={t('LoadCharges')}
                borderColor={'var(--color-blue)'}
                backgroundColor={'var(--color-blue)'}
                labelColor={'var(--color-white)'}
                icon={
                  <Search
                    color="var(--color-white)"
                    style={{ color: 'var(--color-white)' }}
                  />
                }
                onClick={() => setOpenSettingsPopup(true)}
              />
              <M_Button
                bold
                normal
                hoverEffect
                label={t('Add')}
                borderColor={'var(--color-blue)'}
                backgroundColor={'var(--color-blue)'}
                labelColor={'var(--color-white)'}
                icon={
                <Add
                    color="var(--color-white)"
                    style={{ color: 'var(--color-white)' }}
                />
                }
                onClick={() => newCharge(!dataState.counterCharges || dataState.counterCharges < 1)}
              />
              /> */}
                <M_Button
                    bold
                    normal
                    hoverEffect
                    label={t('Add')}
                    icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t('Add')} style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)' }} className='iconCreateBooking' />}
                    borderColor={'var(--color-grey)'}
                    onClick={() => newCharge(!dataState.counterCharges || dataState.counterCharges < 1)}
                />
            </div>
          )
        }
        elements={
          <div
            style={{
              margin: '20px',
            }}
          >
            <M_SimpleTable
              rowGroupMode={'subheader'}
              groupField={'lumpSumCode'}
              headerTemplate={(obj, eventData) => {
                const calcProfit = calculateTotalProfit(obj, eventData)

                if (obj?.lumpSumCode) {
                  return (
                    <span
                      style={{
                        display: (matches10 && 'grid') || 'flex',
                        gridTemplateColumns:
                          'auto auto auto auto auto auto auto auto',
                        backgroundColor: 'var(--color-grey-light)',
                        borderRadius: '15px',
                      }}
                    >
                      <b
                        style={{
                          padding:
                            (matches10 && '10px 10px 10px 50px') || '10px',
                        }}
                      >
                        {t('LumpCode')} :{' '}
                        {obj?.lumpSumCode}
                      </b>
                      <b style={{ padding: '10px 0px', marginLeft: '50px' }}>
                        {t('LumpName')} :{' '}
                        {obj?.lumpSumName}
                      </b>
                      <b
                        style={{
                          padding: '10px',
                          marginLeft: '50px',
                          display: 'flex',
                        }}
                      >
                        {t('TotalCost')} :{' '}
                        {calculateTotalSum(obj, eventData, 'costValue')}
                        {dataState?.quoteCurrencyCode}
                      </b>
                      <b
                        style={{
                          padding:
                            (matches10 && '10px 10px 10px 50px') || '10px',
                          marginLeft: '50px',
                        }}
                      >
                        {t('TotalSales')} :{' '}
                        {calculateTotalSum(obj, eventData, 'salesValue')}
                        {dataState?.quoteCurrencyCode}
                      </b>
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        <b style={{ padding: '10px', marginLeft: '50px' }}>
                          {t('Profit')} :{' '}
                        </b>
                        <b
                          style={{
                            padding: '10px 0px',
                            color:
                              calcProfit > 0
                                ? 'var(--color-green-light)'
                                : calcProfit < 0 && 'var(--color-red)',
                          }}
                        >
                          {calcProfit} {dataState?.quoteCurrencyCode}
                        </b>
                      </span>
                    </span>
                  )
                }
              }}
              footerTemplate={(obj) => {
                if (obj?.lumpSumCode) {
                  return (
                    <td
                      colSpan="11"
                      style={{ backgroundColor: 'var(--color-blue-dark)' }}
                    >
                      <span
                        style={{
                          display: 'flex',
                          backgroundColor: 'var(--color-blue-dark)',
                          height: '1px',
                        }}
                      ></span>
                    </td>
                  )
                }
              }}
              rows={(dataState['charges'] && dataState['charges']) || []}
              columns={[
                ...formFields.map((field, index) => {
                  return {
                    header: field.display,
                    field: field.code,
                    ...field,
                    body: (row) => chargesElements(row, field, index),
                  }
                }),
                {
                  header: '',
                  frozen: true,
                  alignFrozen: 'Right',
                  style: { width: '80px', textAlign: 'right' },
                  body: (row) =>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <M_Button
                          none
                          icon={
                            <Settings style={{ color: 'var(--color-blue)' }} />
                          }
                          onClick={() => openSettings(row)}
                          disable={dataState.isMultiEdit}
                        />
                        <M_Button
                          none
                          icon={<Close style={{ color: 'var(--color-red)' }} />}
                          onClick={() => {
                            deleteCharges(row);
                          }}
                          disable={dataState.isMultiEdit}
                        />
                      </div>
                },
                // { 'header': '', 'body': (row) => row.id !== data.charges[data.charges.length - 1].id && () || <></> }
              ]}
            />
          </div>
        }
      />
      <M_ElementDrawer
        open={openSettingsPopup}
        setOpen={closeSettings}
        onClose={closeSettings}
        element={
          <QuoteChargesSettings
            multipleOptions={multipleOptions}
            dataState={dataState}
            setDataState={setDataState}
            passedRowState={passedRowState}
            setPassedRowState={setPassedRowState}
            onClose={closeSettings}
          />
        }
      />
    </>
    </M_FormFavorites>
  )
}
